import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private router: Router,
              private authService: AuthService) {}

  canActivate(): Promise<boolean> {
    return this.authService.isLoggedIn().then(canActivate => {
      if (!canActivate)
        this.router.navigateByUrl('welcome');
      return canActivate;
    });
  }
}
